import { emailRegex, twoCharsRegex } from '../../common/validation';
import { TFunction } from 'i18next';

export const requiredValidation = (t: TFunction) => ({
  required: { value: true, message: t('common.validation.validation_required') },
});
export const twoCharsValidation = (t: TFunction) => ({
  pattern: {
    value: twoCharsRegex,
    message: t('common.validation.validation_two_chars'),
  },
});
export const emailValidation = (t: TFunction) => ({
  pattern: {
    value: emailRegex,
    message: t('common.validation.validation_email'),
  },
});
